import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(private router: Router) {
     const hostname = window.location.hostname;
     console.log(hostname)

    if (hostname == 'www.trackyourtreads.com' || hostname == 'trackyourtreads.com') {
      this.router.navigate(['/public/ship-track']);
    }
  }
}
